import React from 'react';
import CloudMonitorPage from './CloudMonitorPage';

export default function CloudMonitorM365() {
  return <CloudMonitorPage provider="m365" />;
}
